/** İstemci tarafı e-posta biçimi (sunucu Zod'u asıl kapı; P2-11 — 422'ye düşmeden söyle). */
export function isValidEmail(value: string): boolean {
  const v = value.trim();
  return v.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
}
